@if (skeleton()) {
<lib-skeleton-loader
  [theme]="{
    'height.%': 100,
    'width.%': 100
  }"
></lib-skeleton-loader>
} @else {
<button
  [disabled]="state === 'disabled'"
  [attr.id]="id() ? id() : null"
  [type]="buttonType"
  class="border-1 border-transparent focus-visible:outline focus-visible:outline-ring focus-visible:outline-2 focus-visible:outline-offset-2"
  [ngClass]="{
    'p-[7px] h-[32px] w-[32px]': screen === 'desktop' && size === 'default',
    'p-[13px] h-[44px] w-[44px]': screen === 'mobile' && size === 'default',
    'p-[3px] h-[24px] w-[24px]': screen === 'desktop' && size === 'small',
    'p-[9px] h-[34px] w-[34px]': screen === 'mobile' && size === 'small',
    'opacity-50 cursor-default': state === 'disabled',
    'rounded-full': style === 'rounded',
    'rounded-[6px]': style === 'squared',
    'bg-background': ['default'].includes(type),
    '!border-border-solid': ['outline', 'default'].includes(type),
    'bg-primary text-primary-foreground': type === 'primary',
    'bg-destructive text-destructive-foreground': type === 'destructive',
    'bg-success-fade text-success-foreground': type === 'success',
    'bg-blue-fade text-blue-foreground': type === 'info',
    'bg-secondary !border-border-inverted text-secondary-foreground': type === 'secondary',
    'text-link': type === 'link',
    'text-muted-foreground': ['outline', 'ghost'].includes(type),
    'text-foreground': type === 'default',
    'active:opacity-90 md:hover:opacity-90': ['primary', 'destructive', 'link', 'success', 'info'].includes(type) && state === 'default',
    'active:bg-accent-transparent md:hover:bg-accent-transparent focus-visible:bg-accent-transparent': type === 'ghost' && state === 'default',
    'active:bg-accent-solid md:hover:bg-accent-solid': ['outline', 'default'].includes(type) && state === 'default',
    'active:text-foreground md:hover:text-foreground focus-visible:text-foreground': ['outline', 'ghost'].includes(type) && state === 'default',
    'focus-visible:border-border-solid': type === 'link' && state === 'default',
  }"
>
  @if (icon) {
  <i
    [ngClass]="{
    '!leading-[16px] !text-[16px] !h-[16px]': size === 'default',
    '!leading-[12px] !text-[12px] !h-[12px]': size === 'small',
  }"
    class="fi fi-rr-{{ icon }} block text-{{ iconColor }}"
  ></i>
  } @else {
  <ng-content></ng-content>
  }
</button>
}
